jQuery(document).ready(function(){

      // Listen for keydown event on input fields
      $(document).on('focusout', '[name="q"]', function(event) {
            jQuery(this).closest('form').submit();
    });
  jQuery('.js-mobile-nav-toggle').click(function(){
        window.scrollTo({
  top: 0,
});
      setTimeout(function(){
     if(jQuery('.js-mobile-nav-toggle').hasClass("mobile-nav--close"))
     {
      // jQuery('body').removeClass("hidden-body");
     }
    else
     {
      // jQuery('body').addClass("hidden-body");
     }
      }, 1500);

  })
    jQuery(document).on('click','.main-content', function(e){
    if(jQuery('body').hasClass("nav_show"))
    {
      e.preventDefault();
     jQuery('.mobile-nav--close').trigger("click");
      jQuery('body').removeClass("nav_show");
    }
  });
   jQuery('.banner_slider').slick({
       autoplay: true,
       autoplaySpeed: 5000,
       dots: true,
   });
});
 var swiper = new Swiper(".lookup_slider", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          500: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          992: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
        },
      });

 var swiper = new Swiper(".collection_scrollbar_slider", {
        spaceBetween: 10,
   autoplay: true,
   speed: 500,
       autoHeight: true,
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: true,
        },
      });

let header = document.querySelector("#shopify-section-header");
(onScroll = function () {
    var scrolledPage = Math.round(window.pageYOffset);
    scrolledPage > 50 ? header.classList.add("sticky") : header.classList.remove("sticky");
}),
    document.addEventListener("scroll", onScroll);

jQuery(".js-mobile-nav-toggle").click(function () {
    const is_close = jQuery(this).hasClass('mobile-nav--close');
    // console.log(is_close);
    if(is_close === false)
    {
        jQuery("body").addClass("nav_show");
    }
    else
    {
      jQuery("body").removeClass("nav_show");
    }

    jQuery("html, body").animate({ scrollTop: "0" },  0);
  });

var swiper = new Swiper(".ps_slider", {
      slidesPerView: 2,
      spaceBetween: 10,
      autoplay: true,
      speed: 1000,
      delay: 300,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        576: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 6,
          spaceBetween: 25,
        },
      },
    });

var logoSlider = new Swiper(".logo_brand_slider", {
      slidesPerView: 2,
      spaceBetween: 10,
      autoplay: true,
      speed: 150,
      loop: true,
      delay: 0,
       pagination: {
        el: ".swiper-pagination",
      },
      breakpoints: {
        450: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
        1200: {
          slidesPerView: 6,
          spaceBetween: 15,
        },
        1400: {
          slidesPerView: 8,
          spaceBetween: 15,
        },
      },
    });